module.exports = __webpack_public_path__ + "media/images/product/f_b-b16fe7b65637423108e9759a06e37560.png";